module.exports = __webpack_public_path__ + "static/3-9f1135802972529ba6e1d0db284339a3.png";